// extracted by mini-css-extract-plugin
export var banner = "_pk-0";
export var settingRow = "_pk-2";
export var titleIcon = "_pk-1";